import React from 'react';
import { createContext, useContextSelector } from 'use-context-selector';
import type pluginImageSrcAddParams from '../plugins/plugin-image-src-add-params';
type state = {
  imageReplaceHostOptions?: {
    searchHostname: string[];
    replaceHostname: string;
    customDomainRequestPath?: string;
    isEnterpriseEdition?: boolean;
  };
  imageSrcAddParams?: Parameters<typeof pluginImageSrcAddParams>[0];
  renderExternalLink: (url: string) => string;
  openExternalLink?: (url: string | undefined, e: MouseEvent) => void;
  hasBlockExternalComponent?: (child: any) => boolean;
  ComponentMap?: Record<string, React.FC<any>>;
  slugIdPrefix?: string;
  enableHeadingSlugId?: boolean;
  enableHeadingAutoLink?: boolean;
  isSupportHash?: boolean;
};
export const MarkdownOpenExternalLinkCtx = createContext<state>({});

export const MarkdownOpenExternalLinkCtxCustomer = <T>(props: {
  fn: (S: state) => T;
  children: (state: T) => React.ReactNode;
}) => {
  const state = useContextSelector(MarkdownOpenExternalLinkCtx, props.fn);
  return React.createElement(React.Fragment, {}, props.children(state));
};
